module.exports = __webpack_public_path__ + "img/2020_09_dande_miyashita_fin_web.41d4e77b.jpg";